module.exports = __webpack_public_path__ + "static/media/store-large.18f7d42c.png";